<script>
import Layout from '@layout/main'
// import CountryCodePicker from '@components/Input/CountryCodePicker'
import Login from '@components/Form/Login'
import Registered from '@components/Form/Register'
// import { getLocalStorage } from '@utils/localStorage'

export default {
  page() {
    return {
      title: `會員登入`,
    }
  },
  components: {
    Layout,
    Login,
    Registered,
  },
  data() {
    return {
      // activeTab: this.$route.name === 'registered' ? 'registered' : 'login',
      activeTab: this.$route.query.activeTab === 'registered' ? 'registered' : 'login',
      // isExpired: false,
      // mail: '',
    }
  },
  // destroyed() {
  //   this.mail = ''
  //   this.isExpired = false
  // },
  methods: {
    handleLogin() {
      if(window.localStorage.getItem("fromCampaign")) {
        window.location = window.localStorage.getItem("fromCampaign")
      } else {
        this.$router.push(this.$route.query.redirectFrom || { name: 'member' })
      }
    },
    handleRegistered() {
      this.activeTab = 'login'
    },
    goToResiger() {
      this.$nextTick(() => {
        this.activeTab = 'registered'
      })
    },
    // handleExpired(expiredData) {
    //   this.mail = expiredData.email
    //   this.isExpired = true
    //   console.log('expiredData :>> ', expiredData)
    // },
  },
}
</script>
<template>
  <Layout>
    <BaseBanner :title="activeTab === 'registered' ? '會員註冊' : '會員登入'" :image="require('@assets/images/login/banner.png')" class="d-md-block d-none" custom-class="isStyleWhite" />
    <section :class="$style.sectionLoing" class="section">
      <div class="container--smaller">
        <div class="section__block">
          <!-- <template v-if="isExpired">
            <div class="expired">
              <h2>更新驗證</h2>
              <p>您好，由於您長時間未登入會員</p>
              <p>為了提供更即時的會員服務</p>
              <p>我們會傳送一組驗證連結</p>
              <p>至您的公司電子郵件地址 {{ mail }}</p>
              <p>請至電子郵件收取信件</p>
            </div>
          </template> -->
          <!-- <template v-else> -->
          <el-tabs v-model="activeTab" stretch class="isStyleBase">
            <el-tab-pane label="會員登入" name="login">
              <Login @login="handleLogin" @toResiger="goToResiger" />
            </el-tab-pane>
            <el-tab-pane label="會員註冊" name="registered">
              <Registered @done="handleRegistered" />
            </el-tab-pane>
          </el-tabs>
          <!-- </template> -->
        </div>
      </div>
    </section>
  </Layout>
</template>
<style lang="scss" module>
.sectionLoing {
  // background: $color-gray-2;
  @include max-md {
    background: transparent;
    padding-bottom: 3rem;
  }
  :global {
    .sectionLoing {
    }
    .section__block {
      @include max-md {
        padding: 2px;
        box-shadow: none;
      }
    }
    // .expired {
    //   display: flex;
    //   flex-direction: column;
    //   justify-content: center;
    //   align-items: center;
    //   > h2 {
    //     margin-bottom: 30px;
    //     font-size: 30px;
    //   }
    // }
  }
}
</style>
